import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaDiscord, FaTelegram } from 'react-icons/fa';

function Footer() {
  return (
    <div className='text-center text-white 'style={{marginTop:"10%"}}>
        <div className="d-flex gap-4 mt-4 m-auto" style={{width:"fit-content"}}>
            <a href='https://x.com/PhiliToken' target='blank' className="icon"><FaTwitter /></a>  
            <a href='https://t.me/Philitoken' target='blank' className="icon"><FaTelegram  /></a>  
        </div>
        <p className='my-3 fw-bold'>Copyright © 2024 MARTHY. All Rights Reserved.</p>
    </div>
  );
}

export default Footer;
